import React, { useReducer, useState, useMemo, useEffect } from 'react'
import { Header, Segment, Form, Input, Icon, Table } from 'semantic-ui-react'
import InputMask from 'react-input-mask'
import { toast } from 'react-toastify'
import request from 'services/http'
import { finalize, tap } from 'rxjs/operators'
import { useSubscription } from 'utils'
import { DateTime } from 'luxon'
import RelatorioTabela from './RelatorioTabela'
import history from 'services/history'
import { paramsToSearchURL } from 'utils'

const initialFormValues = {
    restaurante: '01',
    dataIni: '',
    dataFim: '',
    status: '0',
    tipoData: 'id_data_emi',
    item: 1
}

function formReducer(state, action) {
    if ('reset' in action)
        return initialFormValues
    if (!('payload' in action))
        return state
    return { ...state, ...action.payload }
}

export default function Relatorio(props) {

    const [form, setForm] = useReducer(formReducer, initialFormValues)
    const [isSubmitting, setIsSubmitting] = useState(true)
    const [dados, setDados] = useState([])
    const [statusOptions,] = useState([
        { text: 'Em aberto', value: '0' },
        { text: 'Baixadas', value: '1' },
        { text: 'Todas', value: '2' }
    ])
    const [restOptions,] = useState([
        { text: 'Restaurante Dom Pedro 1', value: '01' },
        { text: 'Restaurante Dom Pedro Atibaia', value: '04' },
        { text: 'Hotel Central', value: '08' },
    ])
    const [dataTipoOptions,] = useState([
        { text: 'Emissão', value: 'id_data_emi' },
        { text: 'Vencimento', value: 'id_data_vencto' },
        { text: 'Pagamento', value: 'id_data_pagto' },
        { text: 'Comanda de Pagamento', value: 4 },
    ])
    const [tipoItemOptions,] = useState([
        { text: 'Por Comanda', value: 1 },
        { text: 'Item a item', value: 2 }
    ])

    // GET RELATÓRIO
    const submitRelatorio$ = useMemo(() => request({
        url: `/contas-a-pagar/relatorio${props.location.search}`,
        method: 'GET'
    }).pipe(
        tap(({ response }) => {
            if (response.data.length <= 0) {
                toast.error('Dados não encontrados.')
                return
            } else {
                setDados(response.data)
            }
        }),
        finalize(() => setIsSubmitting(false))
    ), [props.location.search])
    useSubscription(submitRelatorio$, props.location.search)

    function handleChange(event) {
        let name, value
        [name, value] = [event.target.name, event.target.value]
        setForm({ payload: { [name]: value } })
    }

    function handleChangeSelect(_, { name, value }) {
        setForm({ payload: { [name]: value } })
    }

    function handleSubmit() {
        if (!(!!form.dataIni) || !(!!form.dataFim)) {
            toast.error('Por favor, informe as datas corretamente antes de prosseguir.')
            return
        } else {
            let params = {};
            for (let param in form) {
                switch (param) {
                    case 'dataIni':
                    case 'dataFim':
                        params[param] = DateTime.fromFormat(form[param], 'dd/MM/yyyy').toFormat('yyMMdd');
                        break;

                    case 'rest':
                        if (form[param]) {
                            params[param] = form[param];
                        }
                        break;

                    default:
                        if (form[param] || form[param] === '') {
                            params[param] = form[param];
                        }
                }
            }
            history.push({ search: paramsToSearchURL(params) });
        }
        setIsSubmitting(true)
    }

    const limpar = () => {
        history.push({ search: null });
        setDados([]);
        setForm({ reset: true })
    }

    useEffect(() => {
        if(!props.location.search){
            setIsSubmitting(false)
        }
    }, [props.location.search])

    // function handleChangeRadio(_, value) {
    //     let name, valueX
    //     [name, valueX] = [value.name, value.value]
    //     setForm({ payload: { [name]: valueX } })
    // }

    return (
        <div className="col d-flex align-items-center flex-column">
            <Segment basic textAlign='left' style={{ width: '100%', padding: '10px 0px' }}>
                <Form size={'tiny'} onSubmit={handleSubmit}>
                    <Form.Group>
                        <Form.Select
                            width='4'
                            label={
                                <Header as='h5' style={{ margin: 0, marginBottom: 5 }} color='orange'>Restaurante</Header>
                            }
                            options={restOptions}
                            search
                            selectOnBlur={false}
                            placeholder='Selecionar Restaurante'
                            name='restaurante'
                            value={form.restaurante}
                            onChange={handleChangeSelect}
                        />
                        <Form.Field width='2'>
                            <Header floated='left' as='h5' style={{ margin: 0, marginBottom: 5 }} color='orange'>Data</Header>
                            <Header floated='right' as='h5' style={{ margin: 0, marginBottom: 5, color: 'white' }}>-</Header>
                            <Input
                                children={
                                    <InputMask mask="99/99/9999" placeholder='De' value={form.dataIni} name='dataIni' onChange={handleChange} />
                                }
                            />
                        </Form.Field>
                        <Form.Field width='2'>
                            <Header floated='right' as='h5' style={{ margin: 0, marginBottom: 5, color: 'white' }}>-</Header>
                            <Input
                                children={
                                    <InputMask mask="99/99/9999" placeholder='Até' value={form.dataFim} name='dataFim' onChange={handleChange} />
                                }
                            />
                        </Form.Field>
                        <Form.Select
                            width='2'
                            options={statusOptions}
                            label={
                                <Header as='h5' style={{ margin: 0, marginBottom: 5 }} color='orange'>Status</Header>
                            }
                            search
                            selectOnBlur={false}
                            placeholder='Selecionar Status'
                            name='status'
                            value={form.status}
                            onChange={handleChangeSelect}
                        />
                        <Form.Select
                            width='4'
                            options={dataTipoOptions}
                            label={
                                <Header as='h5' style={{ margin: 0, marginBottom: 5 }} color='orange'>Tipo de Data</Header>
                            }
                            search
                            selectOnBlur={false}
                            placeholder='Selecionar'
                            name='tipoData'
                            value={form.tipoData}
                            onChange={handleChangeSelect}
                        />
                        <Form.Select
                            width='3'
                            options={tipoItemOptions}
                            label={
                                <Header as='h5' style={{ margin: 0, marginBottom: 5 }} color='orange'>Tipo de Item</Header>
                            }
                            search
                            selectOnBlur={false}
                            placeholder='Selecionar'
                            name='item'
                            value={form.item}
                            onChange={handleChangeSelect}
                        />
                        <Form.Button size='small' label={'\u00A0'} disabled={isSubmitting} floated='right' icon labelPosition='left' color='vk'>
                            <Icon name='arrow right' />
                            Enviar
                        </Form.Button>
                    </Form.Group>
                </Form>
                <Segment color='grey' loading={isSubmitting} basic={true} style={{ margin: 0, padding: '0px 0px', marginBottom: '10px' }} textAlign='center'>
                    {dados.length > 0 ? (
                        <RelatorioTabela dados={dados} form={form} setDados={setDados} limpar={limpar} props={props} />
                    ) :
                        <Table color='grey' size='small' singleLine textAlign='center' compact='very'>
                            <Table.Header>
                                <Table.Row>
                                    <Table.HeaderCell>Data Emissão</Table.HeaderCell>
                                    <Table.HeaderCell>Data Vencto</Table.HeaderCell>
                                    <Table.HeaderCell>Data Pagto</Table.HeaderCell>
                                    <Table.HeaderCell>Dif. Vencto x Pagto</Table.HeaderCell>
                                    <Table.HeaderCell>Nº Controle</Table.HeaderCell>
                                    <Table.HeaderCell>Valor</Table.HeaderCell>
                                </Table.Row>
                            </Table.Header>
                            <Table.Body>
                                <Table.Row>
                                    <Table.Cell colSpan='6' style={{ height: '50vh' }}>
                                        Preencha os campos acima para fazer uma busca!
                                    </Table.Cell>
                                </Table.Row>
                            </Table.Body>
                        </Table>
                    }
                </Segment>
            </Segment>
        </div>
    )
}